import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core'
import { UtilsService } from 'src/app/services/utils/utils.service'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { CommonModule } from '@angular/common'
import { IonicModule } from '@ionic/angular'

@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule]
})
export class SearchbarComponent implements OnInit, OnDestroy {
  @Input() items: any[] = []
  @Input() alt: boolean = false
  @Input() mask: string = '' // Nueva propiedad para la máscara
  @Output() searchResults = new EventEmitter<any[]>()
  @Output() isFocus = new EventEmitter<boolean>()
  @Output() searchTermChange = new EventEmitter<string>()
  @Output() onExactCoincidence = new EventEmitter<any>()

  isWeb: boolean = false
  searchTerm: string = ''
  placeholder: string = 'Buscar...'
  private langSub: Subscription | null = null

  constructor(private utilsService: UtilsService, private translate: TranslateService) {}

  async ngOnInit() {
    this.isWeb = await this.utilsService.detectIsWeb()

    // Si hay máscara, actualizar el placeholder
    if (this.mask) {
      this.placeholder = this.mask
    }
  }

  ngOnDestroy(): void {
    if (this.langSub) this.langSub.unsubscribe()
  }

  onSearch(value: string) {
    this.searchTerm = value.trim()

    // Emitir el término de búsqueda para que el componente padre maneje la lógica
    this.searchTermChange.emit(this.searchTerm)

    // Manejar el estado de foco
    if (this.searchTerm !== '') {
      this.isFocus.emit(true)
    } else {
      this.isFocus.emit(false)
    }

    // Filtrar localmente solo si hay items cargados
    if (this.items && this.items.length > 0) {
      const filtered = this.searchTerm ?
        this.items.filter((item) =>{
          return item.title?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          item.description?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          item.name?.toLowerCase().includes(this.searchTerm.toLowerCase())
        }
        ) : [...this.items]

      this.searchResults.emit(filtered)
    } else {
      // Si no hay items, emitir array vacío
      this.searchResults.emit([])
    }
  }

  clearSearch(inputElement: HTMLInputElement) {
    this.searchTerm = ''
    inputElement.value = ''
    this.searchTermChange.emit('')
    this.isFocus.emit(false)
    this.searchResults.emit([...this.items])
  }

  setPlaceholder(text: string) {
    // Only change placeholder when there's no mask active.
    if (!this.mask) {
      // Use TranslateService to obtain translated placeholder so we don't need pipes in action expressions
      this.placeholder = this.translate.instant('LISTING.SEARCH_PLACEHOLDER') || text || ''
      // Subscribe once to language changes to keep placeholder reactive (if not already subscribed)
      if (!this.langSub) {
        this.langSub = this.translate.onLangChange.subscribe(() => {
          if (!this.mask) this.placeholder = this.translate.instant('LISTING.SEARCH_PLACEHOLDER')
        })
      }
    }
  }
}
